/**
 * Form widget input validation types
 * Defined in FormWidgetInputValidationType.java
 */

export default {
	INPUT_OPTIONAL: 'input-optional',
	INPUT_REQUIRED: 'input-required',
	MINIMUM_LENGTH: 'minimum-length',
	MAXIMUM_LENGTH: 'maximum-length',
	MINIMUM_MAXIMUM_LENGTH: 'minimum-maximum-length',
	CUSTOM_EXPRESSION: 'custom-expression'
}